// src/components/ActivityMonitor.jsx
import { useEffect } from 'react';
import authService from '../services/authService';

const ActivityMonitor = ({ isAdmin = false }) => {
  useEffect(() => {
    // Keep session alive on user activity
    const refreshTokenOnActivity = () => {
      if (authService.isAuthenticated(isAdmin)) {
        authService.refreshTokenExpiry(isAdmin);
      }
    };

    // Set up activity listeners
    window.addEventListener('click', refreshTokenOnActivity);
    window.addEventListener('keypress', refreshTokenOnActivity);
    window.addEventListener('scroll', refreshTokenOnActivity);
    window.addEventListener('mousemove', refreshTokenOnActivity);

    // Check authentication status periodically
    const intervalCheck = setInterval(() => {
      if (!authService.isAuthenticated(isAdmin)) {
        // Token expired, redirect to login
        window.location.href = isAdmin ? '/admin-login' : '/login';
      }
    }, 10*60000); // Check every minute

    // Clean up
    return () => {
      window.removeEventListener('click', refreshTokenOnActivity);
      window.removeEventListener('keypress', refreshTokenOnActivity);
      window.removeEventListener('scroll', refreshTokenOnActivity);
      window.removeEventListener('mousemove', refreshTokenOnActivity);
      clearInterval(intervalCheck);
    };
  }, [isAdmin]);

  return null;
};

export default ActivityMonitor;
